module.exports = __webpack_public_path__ + "static/media/天恩桥在线.f59ba128.jpg";